import { render, staticRenderFns } from "./jhi-navbar.vue?vue&type=template&id=39b7de9c&scoped=true&"
import script from "./jhi-navbar.component.ts?vue&type=script&lang=ts&"
export * from "./jhi-navbar.component.ts?vue&type=script&lang=ts&"
import style0 from "./jhi-navbar.vue?vue&type=style&index=0&id=39b7de9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b7de9c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39b7de9c')) {
      api.createRecord('39b7de9c', component.options)
    } else {
      api.reload('39b7de9c', component.options)
    }
    module.hot.accept("./jhi-navbar.vue?vue&type=template&id=39b7de9c&scoped=true&", function () {
      api.rerender('39b7de9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/core/jhi-navbar/jhi-navbar.vue"
export default component.exports